import React from "react";
import PropTypes from "prop-types";
import ctl from "@netlify/classnames-template-literals";
import { Button, Container, Text } from "components";
import { MailingListForm } from "components/layout/mailing-list";

const PageHeader = ({
  title = "",
  subheading = "",
  getStarted,
  button,
  secondButton,
  center,
  theme,
  animatedBackground,
}) => {
  const headerWrapperStyle = ctl(`
  ${headerWrapperBaseStyle}
  ${center && "text-center"}
  ${headerTheme[theme]}
  ${backgroundImage[Number(animatedBackground)]}
  ${backgroundHeight[Number(animatedBackground)]}

  `);
  return (
    <header className={headerWrapperStyle}>
      <Container>
        <>
          <Text variant="h1" value={title} className="mb-5" />

          <Text variant="p21" value={subheading} className="mb-[21px]" />
          {getStarted && (
            <div className={callToActionWrapperStyle}>
              <MailingListForm isDark buttonText="Get Started" />
            </div>
          )}

          <div>
            {button && <Button hasArrow size="small" {...button} />}
            {secondButton && (
              <Button
                hasArrow
                size="small"
                {...secondButton}
                addClass={buttonStyling}
              />
            )}
          </div>
        </>
      </Container>
    </header>
  );
};

PageHeader.propTypes = {
  title: PropTypes.any.isRequired,
  subheading: PropTypes.any,
};

const headerWrapperBaseStyle = ctl(`
min-h-screen
bg-cover
flex
items-center
md:pt-[104px]
pt-[72px]
pb-[54px]
`);

const backgroundHeight = [`min-h-[92vh]`, `md:min-h-screen min-h-[90vh]`];

const headerTheme = {
  dark: `
  bg-secondary
  text-secondary-100
  `,
  light: `
  text-secondary
  bg-secondary-100
  `,
};

const backgroundImage = [
  `bg-[url('../assets/images/brand-pattern.png')]
  `,
  `bg-[url('../assets/images/brand-pattern.gif')]
`,
];

const callToActionWrapperStyle = ctl(`
max-w-[650px]
mt-[24px]
`);

// const headerCTA = ctl(`
//   flex
//   gap-[10px]
//   max-[361px]:flex-col
// `);

const buttonStyling = ctl(`
  bg-white
`);

PageHeader.defaultProps = {
  theme: "dark",
  animatedBackground: false,
};

export { PageHeader };
